import React, { useEffect } from 'react';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { useHistory } from 'react-router-dom';
import { formatAMPM, formatDate, handleLinks } from '../../utils';
import s from './style.css';
const VaultNote = (props) => {
    const { note, handleContextMenu } = props;
    const history = useHistory();
    useEffect(() => {
        handleLinks(note.id.toString());
    }, []);
    return (React.createElement("div", { className: s.container, role: 'button', tabIndex: 0, onContextMenu: (e) => handleContextMenu(e), onClick: (e) => {
            if (e.target.tagName !== 'A') {
                history.push('/vault/notes/create-note', { note });
            }
        }, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (e.target.tagName !== 'A') {
                    history.push('/vault/notes/create-note', { note });
                }
            }
        } },
        React.createElement("div", null,
            React.createElement("p", { className: s.text, id: note.id.toString() }, note.text?.split('\n').slice(0, 3).join('\n')),
            React.createElement("p", { className: s.date }, `${formatDate(note.timestamp)}, ${formatAMPM(note.timestamp)}`)),
        React.createElement(BiDotsHorizontalRounded, { size: 24, color: 'grey', role: 'button', tabIndex: 0, onClick: (e) => {
                e.stopPropagation();
                handleContextMenu(e, true);
            } })));
};
export default VaultNote;
